<div class="sos-content" *ngIf="hasIncluirAvalista()">
  <h4>Avalista</h4>
  <button *ngIf="!proposta?.avalistas?.length" class="btn btn-border-orange" title="Incluir Avalista" (click)="openModalWithComponent()">Incluir Avalista</button>

  <div *ngIf="proposta?.avalistas?.length" class="informed-avalista">
      <h5>{{ proposta.avalistas[0].nome }}</h5>
      <a (click)="proposta.avalistas = []">
          <span class="glyphicon glyphicon-trash"></span>
      </a>
  </div>

  <div *ngIf="isAvalistaObrigatorio" class="alert alert-danger alert-dismissable">
      <strong>Avalista é obrigatório</strong>
  </div>
</div>